import { Layout } from '../components/Layout';
import { Card } from '../components/ui';

export default function Placeholder({ title }: { title: string }) {
  return (
    <Layout title={title}>
      <Card className="p-10 text-center">
        <div className="text-4xl mb-3">🚧</div>
        <h2 className="text-lg font-semibold text-ink-900">{title}</h2>
        <p className="text-sm text-slate-500 mt-1">
          Module still on the current SSR — it will be migrated in this phase.
          <br />
          In the meantime, use the production version.
        </p>
      </Card>
    </Layout>
  );
}
